import React from "react";
import PropTypes from 'prop-types';
import LoginLoader from "../LoginLoader/LoginLoader";
import ModelInfoPopup from '../Onboarding/SubComponents/ModelInfoPopup/ModelInfoPopup';
import "./Login.css";
import { Link } from "react-router-dom";
import "../Onboarding/Pages/Details.css";

const Login = (props) => {
  const { login: {name, password, failureMessage, formValidity, failure, loader } , submitHandler, changeEventHandler, showSignUpPage, signup, getOtp, changeRegNo, submitGstin, resendOTPaxiosCall, model_info, show_model_info_popup, toggleModelInfoPopup, categorySelector } = props,
  isMobile = ((typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1));

  const continueState = () => {
    if(signup && signup.gstin && signup.reg_no && (signup.gstin.value || signup.gstToggle.value) && signup.reg_no.value && signup.reg_no.value.length === 10 && !signup.otp.resend && !signup.otp.showTimer && typeof(signup.reg_no.error) === "string" && signup.reg_no.error === "") {
      return true;
    } else {
      return false;
    }
  }

  const signupBtnState = () => {
    if(signup && signup.model && signup.gstin && signup.reg_no && signup.model.disabled && signup.gstin.disabled && signup.reg_no.disabled && typeof(signup.otp.value) === "string" && signup.otp.value !== "" && signup.otp.value.length === 4) {
      return true;
    } else {
      return false;
    }
  } 

  return (
    <div>
      <div className={`hvh100 pF l0 r0 t0 bm0 wp100 mA bgL ${isMobile ? "loginbgmob" : "loginbgdesktop"}`}></div>
      <div className="hvh100 oyS pb96">
        <div className="p016 pR t60 mA w420 mxwp90">
          <div className="p16 br4 pb50 bgF bs1159">

            <div className="m20A mxwp90 taC">
              <svg style={{width: "110px", fill: "#99CC33"}} id="lLogo" viewBox="0 0 116 23" xmlSpace="preserve">
                  <path d="M92.76 8.244c-1.806 0-3.506 3.833-3.506 6.63 0 .803.156 2.379 1.195 2.379 1.335 0 2.385-2.065 2.805-3.795l.328-1.348c.122-.482.255-1.285.255-1.827 0-.844-.266-2.04-1.077-2.04zm6.241 9.676c-1.273.789-2.863 1.324-3.936 1.324-1.598 0-2.853-.872-2.116-3.084-.796 1.468-2.325 3.084-4.245 3.084-2.274 0-4.087-1.7-4.087-4.565 0-3.473 2.855-7.965 7.106-7.965 1.743 0 2.784 1.034 3.065 2.537l.302-1.119c.197-.808.899-1.372 1.707-1.372h2.556s-2.199 9.097-2.337 9.607c-.139.51-.038 1.11.659 1.11.222 0 .862-.072 1.325-.125l.001.568zm8.405-9.676c-2.034 0-3.51 4.05-3.51 6.63 0 .981.215 2.379 1.242 2.379 1.045 0 2.465-1.55 2.946-3.792l.354-1.654c.107-.44.159-.875.159-1.33 0-.47-.082-2.233-1.191-2.233zm4.503 8.133c-.18.748.152 1.1.658 1.1.407 0 .939-.085 1.32-.126v.57c-1.467.89-2.869 1.323-3.941 1.323-2.092 0-2.633-1.227-2.261-3.044-.86 1.562-2.124 3.044-4.292 3.044-2.501 0-4.182-1.7-4.182-4.565 0-3.443 2.808-7.965 6.988-7.965 1.357 0 2.526.994 2.965 2.15 0 0 1.065-4.506 1.287-5.41.221-.904.108-1.71-.523-2.164V.813h3.45c1.227 0 2.004.962 1.707 2.249-.296 1.286-2.997 12.566-3.176 13.315zm-68.067.977s-.853.12-1.281.12c-.841 0-.795-.773-.664-1.32l1.318-5.503c.097-.428.147-.837.147-1.217 0-1.744-1-2.72-2.736-2.72-1.885 0-3.527 1.205-4.714 3.14.155-1.835-.76-3.14-2.434-3.14-1.824 0-3.125 1.026-4.296 2.813l.087-.323c.264-.933-.195-2.248-1.708-2.248h-3.47v.477c.69.437.798 1.145.557 2.147l-2.272 9.421h4.533l1.245-5.174c.794-3.293 2.055-4.466 2.97-4.466.424 0 .6.442.463 1.01l-1.38 5.727c-.222.922-.113 1.707.315 2.27.435.573 1.178.876 2.148.876 1.101 0 2.791-.66 3.62-1.506l-.159-.541c-.312.159-.745.285-1.099.285-.326 0-.535-.252-.422-.734l.685-2.925c.795-3.293 2.055-4.466 2.97-4.466.494 0 .59.566.48 1.014l-1.307 5.39c-.116.51-.17.904-.17 1.241 0 1.023.459 2.242 2.648 2.242 1.072 0 2.46-.423 3.926-1.324v-.566zm-21.91-.002c-.356.041-1 .127-1.245.127-.72 0-.858-.61-.73-1.151.128-.54 1.415-5.98 1.701-7.12.286-1.141-.324-2.251-1.707-2.251h-3.478v.476c.667.572.78 1.254.566 2.148l-1.48 6.18c-.117.51-.17.904-.17 1.241 0 1.023.459 2.242 2.648 2.242 1.052 0 2.468-.458 3.896-1.324v-.568zm41.295-6.85c2.796 0 4.91-1.806 4.91-4.735 0-1.6-1.128-2.671-3.03-2.671h-1.743c.247.363.265.867.067 1.74-.07.311-1.109 4.577-1.374 5.666h1.17zm13.668 9.865l.313.666-.167.107c-1.431.924-3.059 1.398-4.873 1.398-3.857 0-6.27-1.682-8.33-6.361l-1.659-4.142c-.094-.234-.245-.33-.4-.33h-.07l-1.444 5.912c-.196.808-.898 1.372-1.707 1.372h-4.09v-.465c.673-.397 1.078-1.091 1.337-2.148.565-2.3 1.47-5.802 2.186-8.763.432-1.784.562-2.298.562-2.298.243-.982.407-2.026-.34-2.84v-.478h8.76c3.503 0 5.855 1.099 5.855 4.062 0 2.762-3.47 4.977-6.83 5.372 1.01.385 1.859 1.723 2.377 3.103.595 1.582 2.405 6.52 5.437 6.52.904 0 2.027-.292 2.895-.617l.188-.07zm-1.702-4.086c0 1.22.437 1.894 1.03 1.894 1.757 0 3.27-5.775 3.27-8.499 0-.944-.252-1.894-1.03-1.894-1.756 0-3.27 5.775-3.27 8.5zm1.148 2.963c-3.404 0-5.69-1.875-5.69-5.002 0-3.483 3.147-7.528 7.694-7.528 3.587 0 5.691 2.555 5.691 5.002 0 3.606-3.359 7.528-7.695 7.528zM51.516 7.782c-1.382 0-2.494 2.363-2.846 4.947 2.834-.514 3.494-2.285 3.494-3.805 0-.61-.18-1.142-.648-1.142zm3.19 8.478c-1.315 2.085-3.726 2.984-5.718 2.984-2.524 0-4.984-1.832-4.984-4.832 0-4.14 3.431-7.698 7.649-7.698 2.64 0 4.275 1.375 4.275 2.962 0 2.997-3.764 3.776-7.273 3.903.015 2.002.976 3.65 2.597 3.65 1.169 0 2.058-.61 2.881-1.471l.573.502zM22.86 3.12c0-1.448-1.122-2.582-2.554-2.582-1.443 0-2.531 1.11-2.531 2.582 0 1.458 1.088 2.558 2.53 2.558A2.529 2.529 0 0 0 22.86 3.12zm-8.737 11.745l.378.009-.667 2.852c-.174.75-.818 1.275-1.567 1.275H.332v-.477l.071-.067c.71-.667 1.04-1.22 1.258-2.11L4.813 3.37c.196-.809.898-1.373 1.707-1.373h4.125v.477s-1.033.798-1.328 2L8.49 7.893c-.765 3.162-1.76 7.326-1.923 7.97a6.618 6.618 0 0 1-.658 1.672c1.178-.04 4.828-.36 8.157-2.631l.056-.039z"></path> 
              </svg>
              <div style={{letterSpacing: "2.5px", fontSize: "8px", fontWeight: "500", lineHeight: "0", color: "#99CC33" }}>SELLER PLATFORM</div>
            </div>
              
            { !signup.display ? (
              <React.Fragment>
                <div className="p036">
                  <h3 className="ttU taC fs24 lh48 fwL cdL">Login</h3>
                  <form className="taC" onSubmit={submitHandler}>
                    <div className="m160">
                      <input
                        id="name"
                        type="text"
                        className="form-control p812 dB wp100 fs14 c5 br4 bd1C bs oN tbcbs"
                        name="name"
                        placeholder="Username"
                        value={name}
                        onChange={(e) => changeEventHandler(e,"login")}
                      />
                      <br />
                      <input
                        id="password"
                        type="password"
                        className="form-control p812 dB wp100 fs14 c5 br4 bd1C bs oN tbcbs"
                        name="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => changeEventHandler(e,"login")}
                      />
                    </div>
                    <button
                      className="bd0 bgL br4 cF mb10 mt12 oN p1525 submit-button ttU wp100"
                      type="submit"
                      disabled={!formValidity}
                    >
                      { loader ? (<div className="pR pr36">Validating<div className="login-loader pA"><LoginLoader /></div></div>) : (<span>Login</span>)}
                    </button>
                    {/*<div className="cGld ffMo fs12 lh15 mb10">Or</div>*/}
                    {/* <Link to="/onboarding"> */}
                    {/*<div onClick={showSignUpPage} className="bdL br4 bs011D c5 ffMo fs12 fw500 p1525 wp100 cuP ttU">SIGN UP</div>*/}
                    {/* </Link> */}
                  </form>
                </div>
                <div className="p024 taC h16 cR fs14">
                  { failure ? (<span>{failureMessage}</span>) : (null)}
                </div>
                <div className="p024 m188 taC">
                  <div className="cGld fs12 fw500 lh15 ffMo">Reset your password 
                    <a
                      className="fs12 c5"
                      href="http://vendor.trunkroute.com/forgotPassword"
                    >
                      <span className="cP fwB"> here</span>
                    </a>
                  </div>
                </div>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <h3 className="ttU fs24 lh48 fwL cdL taC">Sign Up</h3>
                {signup.showInitialView ? (
                  <div className="ffMo fs12 lh15 p036 taC">
                    {/*<div onClick={ () => categorySelector("live") } className={`lgnbtnhvr bgL br4 cF cuP fw500 mA mt24 mxw220 p1525 ta02 ttU`}>LR Live Seller</div>*/}
                    <div onClick={ () => categorySelector("core") } className={`lgnbtnhvrP bgP br4 cF cuP fw500 mA mt24 mxw220 p1525 ta02 ttU`}>Core Seller</div>
                  </div>
                ) : (
                  <div className="ffMo fs12 lh15 p036 taC">
                    {signup.category === "live" && (
                      <div className="c5 fwB pt12">
                          { signup && signup.model && signup.model.disabled ? (
                            <div className="cP">Model {signup && signup.model && signup.model.value}</div>
                          ) : (
                            <React.Fragment>
                              <div className="dIb">Select your model</div>
                              <div className="dIb">
                                <select
                                  className="bd0 bgF cP wp100"
                                  onChange={(e) => changeEventHandler(e, "signup")}
                                  value={signup.model.value}
                                  name="onboarding_model"
                                  id="model"
                                  disabled={signup && signup.model && signup.model.disabled}
                                >
                                  {/* <option value="">Choose Model</option> */}
                                  {/* <option value="1">Model 1</option> */}
                                  <option value="2">Model 2</option>
                                </select>
                              </div>
                              { signup && !!signup.model && !!signup.model.error ? (
                                <div className="cP fs10 fsI fw500 lh12 taC">{signup.model.error}</div>
                              ) : null}
                          </React.Fragment>
                          ) }
                      </div>
                    )}

                    <div className="m160 taL">
                      {signup && signup.gstin && signup.gstin.disabled ? (
                        <>{ signup.gstin.value ? (<div className="c5 fwB">GSTIN: {signup.gstin.value}</div>) : null }</>
                      ) : (
                        <React.Fragment>
                          <input 
                            className={`wp100 details-input ttU ${signup && !!signup.gstin && !!signup.gstin.error ? "input-error" : null }`}
                            onChange={(e) => changeEventHandler(e, "signup")}
                            value={signup.gstin.value}
                            type="text"
                            name="onboarding_gstin"
                            id="gstin"
                            placeholder="GSTIN / Unique ID"
                            maxLength="15"
                            disabled={signup && signup.gstin && signup.gstin.no_gst}
                          />
                          { signup && !!signup.gstin && !!signup.gstin.error ? (
                            <div className="cP fs10 fsI fw500 lh12 taL">{signup.gstin.error}</div>
                          ) : null}
                        </React.Fragment>
                      )}
                    </div>

                    { signup && signup.gstToggle && signup.gstToggle.disabled ? null : (
                      <div className="m160 taL">
                          <div id="gst_toggle" className="dF aiC">
                              <div id="gst_toggle" onClick={(e) => changeEventHandler(e, "signup")} className={`dF aiC`}>
                                  <svg id="gst_toggle" width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <rect id="gst_toggle" x="0.25" y="0.25" width="14.5" height="15.5" rx="0.75" fill={ signup && signup.gstToggle && signup.gstToggle.value ? "#FFFFFF" : "#F7F6F4"} stroke={ signup && signup.gstToggle && signup.gstToggle.value ? "#99CC33" : "#DAD4C9"} strokeWidth="1"/>
                                      { signup && signup.gstToggle && signup.gstToggle.value && (<path id="gst_toggle" d="M5.75003 9.45002L3.70836 7.40835C3.48086 7.18085 3.11919 7.18085 2.89169 7.40835C2.66419 7.63585 2.66419 7.99752 2.89169 8.22502L5.33586 10.6692C5.56336 10.8967 5.93086 10.8967 6.15836 10.6692L12.3417 4.49169C12.5692 4.26419 12.5692 3.90252 12.3417 3.67502C12.1142 3.44752 11.7525 3.44752 11.525 3.67502L5.75003 9.45002Z" fill="#99CC33"/>) }
                                  </svg>
                              </div>
                              <div id="gst_toggle" className="cGld fs10 fsI pl12">{signup && signup.gstToggle && signup.gstToggle.placeholder}</div>
                          </div>
                      </div>
                    )}

                    <div className="m160 pR taL">
                      { signup && signup.reg_no && signup.reg_no.disabled ? (
                        <React.Fragment>
                          <div className="c5 fwB">Mob: {signup.reg_no.value}</div>
                          { signup && signup.reg_no && signup.reg_no.disabled ? (
                            <div onClick={changeRegNo} className="pA r0 t0 cP cuP pr6">Change</div>
                          ) : null }
                          <div className="c5 fs10 fsI pt4">OTP sent to above mobile number</div>
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          <input 
                            className={`wp100 details-input ${signup && !!signup.reg_no && !!signup.reg_no.error ? "input-error" : null }`}
                            onChange={(e) => changeEventHandler(e, "signup")}
                            value={signup.reg_no.value}
                            type="text"
                            name="onboarding_reg_no"
                            id="reg_no"
                            placeholder="Registered mobile no."
                            maxLength="10"
                            disabled={signup && signup.reg_no && signup.reg_no.disabled}
                          />
                          { signup && !!signup.reg_no && !!signup.reg_no.error ? (
                            <div className="cP fs10 fsI fw500 lh12 taL">{signup.reg_no.error}</div>
                          ) : null}
                        </React.Fragment>
                      ) }                    
                    </div>

                    { signup && signup.otp && !signup.otp.disabled ? (
                      <React.Fragment>
                        <div className="m160 pR">
                          <input 
                            className={`wp100 details-input mb10 ${signup && !!signup.otp && !!signup.otp.error ? "input-error" : null }`}
                            onChange={(e) => changeEventHandler(e, "signup")}
                            value={signup.otp.value}
                            type="text"
                            name="onboarding_otp"
                            id="otp"
                            placeholder="OTP"
                            maxLength="4"
                            disabled={signup && signup.otp && (signup.otp.show_disabled_otp || signup.otp.disabled)}
                          />
                          { signup && signup.otp && signup.otp.showTimer ? (
                            <div className="pA r0 t12 cP pr6">{signup.otp.timer < 10 ? `00:0${signup.otp.timer}` : `00:${signup.otp.timer}`}</div>
                          ) : null }
                          { signup && signup.otp && signup.otp.resend ? (
                            <div onClick={resendOTPaxiosCall} className="pA r0 t12 cP cuP pr6">Resend</div>
                          ) : null }
                          { signup && !!signup.otp && !!signup.otp.error ? (
                            <div className="cP fs10 fsI fw500 lh12 taL">{signup.otp.error}</div>
                          ) : (
                            <div className="cGld fs10 fsI fw500 lh12 taL">Enter OTP sent to your registered mobile number</div>
                          )}
                        </div>

                        { signup.continueSignUpLoading ? (
                          <div className="br4 bs011D ffMo fs12 fw500 lh18 m160 p1525 wp100 ta02 bgB cF cuNA signupbtnbrdr dF jcC aiC pR">
                            <div className="">Validating</div>
                            <div className="w50"><div className="login-loader pA" style={{top: "-18px"}}><LoginLoader /></div></div>
                          </div>
                        ) : (
                          <div onClick={signupBtnState() ? submitGstin : null} className={`br4 bs011D ffMo fs12 fw500 lh18 m160 p1525 wp100 ta02 ${signupBtnState() ? "bdL c5 cuP" : "bgB cF cuNA signupbtnbrdr"}`}>Continue Sign up</div>
                        )}
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        { signup.continueBtnLoading ? (
                          <div className="aiC bgB br4 cF cuNA dF fw500 jcC mA mt12 p1025 pR ttU w160">
                            <div className="">Validating</div>
                            <div className="w50"><div className="login-loader pA" style={{top: "-24px", right: "0px"}}><LoginLoader /></div></div>
                          </div>
                        ) : (
                          <div onClick={ continueState() ? getOtp : null } className={`br4 cF dIb fw500 mt12 p10 ttU w120 ta02 ${continueState() ? "bgL cuP" : "bgB cuNA"}`}>continue</div>
                        )}
                      </React.Fragment>
                    )} 
                    {(model_info && show_model_info_popup) ? <ModelInfoPopup model_info={model_info} toggleModelInfoPopup={toggleModelInfoPopup} /> : null}
                    <div className="cGld fs12 fw500 lh15 pt36">Read more about models <span className="cP fwB" onClick={toggleModelInfoPopup}>here</span></div>
                  </div>
                )}

              </React.Fragment>
            ) }
          </div>
        </div>
      </div>
    </div>
  );
};

Login.propTypes = {
  login: PropTypes.object.isRequired,
  changeEventHandler: PropTypes.func,
  submitHandler: PropTypes.func
};

export default Login;
